import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import { styled } from "@mui/styles";
import { validator, krType } from "../DataSet";

import { useSelector, useDispatch } from "react-redux";
import { getUserProfile } from "../../../../../actions/user";
import {
  postIdvPlan,
  putIdvPlan,
} from "../../../../../actions/IndividualPlans";

// Components
import {
  ButtonGroup,
  Button,
  Grid,
  Typography,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Avatar,
  InputAdornment,
  Select,
  IconButton,
  Box,
  Container,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import  {LocalizationProvider}  from "@mui/x-date-pickers/LocalizationProvider";
import  {DatePicker}  from "@mui/x-date-pickers/DatePicker";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import CircleIcon from "@mui/icons-material/Circle";
import StarIcon from "@mui/icons-material/Star";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import NotesIcon from "@mui/icons-material/Notes";
import Crop32Icon from "@mui/icons-material/Crop32";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import EscalatorIcon from "@mui/icons-material/Escalator";
import EqualizerIcon from "@mui/icons-material/Equalizer";

const InitialValues = () => ({
  planIdvId: 0,
  objectiveName: "",
  impactName: "",
  quater: "Q1",
  keyResult1: "",
  description1: "",
  scope1: "",
  tactics1: "",
  dateStart1: null,
  dateEnd1: null,
  validPerson1: "",
  measureEvidence1: "",
  commitQuality1: "",
  krType1: "",
  keyResult2: "",
  description2: "",
  scope2: "",
  tactics2: "",
  dateStart2: null,
  dateEnd2: null,
  validPerson2: "",
  measureEvidence2: "",
  commitQuality2: "",
  krType2: "",
  keyResult3: "",
  description3: "",
  scope3: "",
  tactics3: "",
  dateStart3: null,
  dateEnd3: null,
  validPerson3: "",
  measureEvidence3: "",
  commitQuality3: "",
  krType3: "",
  createByEmpId: null,
  dateCreate: new Date(),
  planStatus: "Waiting Approval",
});

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#222f3e",
    },
    "& .MuiOutlinedInput-root": {
      padding: "16.5px 14px",
      font: "inherit",
    },
    "& .MuiFormControl-root": {
      margin: "12px 8px",
    },
  },
  errorMessage: {
    color: "#ff0033",
    marginTop: 8,
  },
  spaceFromLocationToQ: {
    marginTop: 5,
    fontSize: 18,
    fontWeight: "bold",
  },
  moonShot_Active: {
    fontSize: "8rem",
    color: "#ff9933",
  },
  moonShot_NotAcive: {
    fontSize: "8rem",
    color: "#bdbdbd",
  },
  circle: {
    color: "#bcbcbc",
  },
  notSelectedQ: {
    backgroundColor: "#bcbcbc",
    width: 16,
    height: 16,
  },
  selectedQ: {
    width: 50,
    height: 50,
  },
  selectedIcon: {
    fontSize: 28,
  },
  name: {
    fontSize: 23,
    fontWeight: "bold",
  },
  placeholder: {
    color: "#aaa",
  },
}));

const ContainerStyled = styled(Container)({
  marginTop: "100px",
});

function IndividualPlan() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const [values, setValues] = useState(InitialValues);
  const [disabled, setDisabled] = useState(false);
  const location = useLocation();
  const [numberQuater, setNumberQuater] = useState(0);
  const [numberKeyResult, setNumberKeyResult] = useState(1);
  const [iconStatus, setIconStatus] = useState(false);
  const [errors, setErrors] = useState({
    objectiveName: false,
    impactName: false,
    keyResult1: false,
  });

  const onPostIdvPlan = async (formData) => {
    await dispatch(postIdvPlan(formData));
    history.push("/individualList");
  };

  const onPutIdvPlan = async (id, formData) => {
    await dispatch(putIdvPlan(id, formData));
    history.push("/individualList");
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (values.objectiveName && values.impactName && values.keyResult1) {
      if (values.planIdvId == 0) {
        const formData = {
          objectiveName: values.objectiveName,
          impactName: values.impactName,
          quater: values.quater,
          keyResult1: values.keyResult1,
          description1: values.description1,
          tactics1: values.tactics1,
          dateStart1: values.dateStart1
            ? dayjs(values.dateStart1).format("YYYY-MM-DD")
            : null,
          dateEnd1: values.dateEnd1
            ? dayjs(values.dateEnd1).format("YYYY-MM-DD")
            : null,
          validPerson1: values.validPerson1,
          measureEvidence1: values.measureEvidence1,
          commitQuality1: values.commitQuality1,
          krType1: values.krType1,
          keyResult2: values.keyResult2,
          description2: values.description2,
          tactics2: values.tactics2,
          dateStart2: values.dateStart2
            ? dayjs(values.dateStart2).format("YYYY-MM-DD")
            : null,
          dateEnd2: values.dateEnd2
            ? dayjs(values.dateStart2).format("YYYY-MM-DD")
            : null,
          validPerson2: values.validPerson2,
          measureEvidence2: values.measureEvidence2,
          commitQuality2: values.commitQuality2,
          krType2: values.krType2,
          keyResult3: values.keyResult3,
          description3: values.description3,
          tactics3: values.tactics3,
          dateStart3: values.dateStart3
            ? dayjs(values.dateStart3).format("YYYY-MM-DD")
            : null,
          dateEnd3: values.dateEnd3
            ? dayjs(values.dateStart3).format("YYYY-MM-DD")
            : null,
          validPerson3: values.validPerson3,
          measureEvidence3: values.measureEvidence3,
          commitQuality3: values.commitQuality3,
          krType3: values.krType3,
          createByEmpId: userProfile.idEmployees,
          dateCreate: dayjs(new Date()).format("YYYY-MM-DD"),
          planStatus: "Waiting Approval",
        };

        onPostIdvPlan(formData);
      } else {
        const formData = {
          planIdvId: values.planIdvId,
          objectiveName: values.objectiveName,
          impactName: values.impactName,
          quater: values.quater,
          keyResult1: values.keyResult1,
          description1: values.description1,
          tactics1: values.tactics1,
          dateStart1: values.keyResult1
            ? dayjs(values.dateStart1).format("YYYY-MM-DD")
            : null,
          dateEnd1: values.keyResult1
            ? dayjs(values.dateEnd1).format("YYYY-MM-DD")
            : null,
          validPerson1: values.validPerson1,
          measureEvidence1: values.measureEvidence1,
          commitQuality1: values.commitQuality1,
          krType1: values.krType1,
          keyResult2: values.keyResult2,
          description2: values.description2,
          tactics2: values.tactics2,
          dateStart2: values.keyResult2
            ? dayjs(values.dateStart2).format("YYYY-MM-DD")
            : null,
          dateEnd2: values.keyResult2
            ? dayjs(values.dateStart2).format("YYYY-MM-DD")
            : null,
          validPerson2: values.validPerson2,
          measureEvidence2: values.measureEvidence2,
          commitQuality2: values.commitQuality2,
          krType2: values.krType2,
          keyResult3: values.keyResult3,
          description3: values.description3,
          tactics3: values.tactics3,
          dateStart3: values.keyResult3
            ? dayjs(values.dateStart3).format("YYYY-MM-DD")
            : null,
          dateEnd3: values.keyResult3
            ? dayjs(values.dateStart3).format("YYYY-MM-DD")
            : null,
          validPerson3: values.validPerson3,
          measureEvidence3: values.measureEvidence3,
          commitQuality3: values.commitQuality3,
          krType3: values.krType3,
        };

        onPutIdvPlan(formData.planIdvId, formData);
      }
    } else {
      setErrors({
        objectiveName: true,
        impactName: true,
        keyResult1: true,
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
    if (location.isInfo == true) {
      //View
      setDisabled(true);
      setValues(location.state.planList);
      setNumberKeyResult(3);
    } else {
      if (location.state.planList !== undefined) {
        //Edit Plan
        setNumberKeyResult(3);
        setValues(location.state.planList);
      } else {
        //Add Plan
        if (currentUser) {
          dispatch(getUserProfile(currentUser.username));
        }

        const date = new Date();
        const month = date.getMonth() + 1;
        const quater = Math.ceil(month / 3);
        setValues({ ...values, quater: "Q" + quater });
        setNumberQuater(quater);
      }
    }
  }, []);

  return (
    <ContainerStyled>
      <div className="card-section">
        <div className="header-section">
          <Grid container>
            <Grid item>
              <h3 className="header-topic">Individual Planning</h3>
            </Grid>
          </Grid>
        </div>
        <form noValidate autoComplete="off">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              xl={2}
              md={2}
              xs={2}
              style={{ textAlign: "-webkit-center" }}
            >
              {values.quater == "Q1" ? (
                <Avatar
                  sx={{ backgroundColor: "primary.main" }}
                  className={classes.selectedQ}
                >
                  <LocationOnIcon className={classes.selectedIcon} />
                </Avatar>
              ) : (
                <Avatar className={classes.notSelectedQ}>
                  <CircleIcon className={classes.circle} />
                </Avatar>
              )}
              <Typography className={classes.spaceFromLocationToQ}>
                Q1
              </Typography>
            </Grid>

            <Grid
              item
              xl={2}
              md={2}
              xs={2}
              style={{ textAlign: "-webkit-center" }}
            >
              {values.quater == "Q2" ? (
                <Avatar
                  sx={{ backgroundColor: "primary.main" }}
                  className={classes.selectedQ}
                >
                  <LocationOnIcon className={classes.selectedIcon} />
                </Avatar>
              ) : (
                <Avatar className={classes.notSelectedQ}>
                  <CircleIcon className={classes.circle} />
                </Avatar>
              )}
              <Typography className={classes.spaceFromLocationToQ}>
                Q2
              </Typography>
            </Grid>
            <Grid
              item
              xl={2}
              md={2}
              xs={2}
              style={{ textAlign: "-webkit-center" }}
            >
              {values.quater == "Q3" ? (
                <Avatar
                  sx={{ backgroundColor: "primary.main" }}
                  className={classes.selectedQ}
                >
                  <LocationOnIcon className={classes.selectedIcon} />
                </Avatar>
              ) : (
                <Avatar className={classes.notSelectedQ}>
                  <CircleIcon className={classes.circle} />
                </Avatar>
              )}
              <Typography className={classes.spaceFromLocationToQ}>
                Q3
              </Typography>
            </Grid>
            <Grid
              item
              xl={2}
              md={2}
              xs={2}
              style={{ textAlign: "-webkit-center" }}
            >
              {values.quater == "Q4" ? (
                <Avatar
                  sx={{ backgroundColor: "primary.main" }}
                  className={classes.selectedQ}
                >
                  <LocationOnIcon className={classes.selectedIcon} />
                </Avatar>
              ) : (
                <Avatar className={classes.notSelectedQ}>
                  <CircleIcon className={classes.circle} />
                </Avatar>
              )}
              <Typography className={classes.spaceFromLocationToQ}>
                Q4
              </Typography>
            </Grid>
          </Grid>

          <Grid container justifyContent="center">
            <Grid item xl={10} md={10} sm={10} xs={10}>
              <TextField
                name="objectiveName"
                value={values.objectiveName}
                onChange={handleInputChange}
                fullWidth
                label="Objective"
                placeholder="Objective"
                disabled={disabled}
                sx={{ paddingTop: 2, paddingBottom: 2 }}
                // variant='outlined'
                // multiline
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <StarIcon />
                    </InputAdornment>
                  ),
                }}
                //{...register("objectiveName", { required: true })}
                /*
                error={errors.objectiveName ? true : false}
                helperText={
                  errors.objectiveName ? "This field is required." : ""
                }
                 */
              />
            </Grid>
            <Grid item xl={10} md={10} sm={10} xs={10}>
              <TextField
                name="impactName"
                value={values.impactName}
                onChange={handleInputChange}
                fullWidth
                disabled={disabled}
                sx={{ paddingBottom: 2 }}
                // multiline
                label="Impact"
                placeholder="Impact"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AutoAwesomeIcon />
                    </InputAdornment>
                  ),
                }}
                //{...register("impactName", { required: true })}
                /*
                error={errors.impactName ? true : false}
                helperText={errors.impactName ? "This field is required." : ""}
                 */
              />
            </Grid>
          </Grid>

          {/* Kr1 */}
          <hr className="hrTag" />
          <Grid
            container
            direction="row"
            style={{ paddingLeft: 30, paddingRight: 30 }}
          >
            <Grid item xl={4} lg={4} md={6} xs={8}>
              <Typography
                sx={{ color: "primary.main" }}
                className={classes.name}
              >
                {/* <VpnKeyRoundedIcon fontSize='large' className='svgKey' /> */}
                Key Result 1
              </Typography>
            </Grid>
            <Grid item xl={8} lg={8} md={6} xs={4} style={{ textAlign: "end" }}>
              {!disabled ? (
                <>
                  {numberKeyResult < 3 ? (
                    <IconButton
                      aria-label="add-demand"
                      style={{
                        marginRight: 5,
                        backgroundColor: "#7dc581",
                        color: "#357a38",
                      }}
                    >
                      <AddIcon
                        onClick={() => {
                          setNumberKeyResult(numberKeyResult + 1);
                        }}
                      />
                    </IconButton>
                  ) : (
                    <IconButton
                      aria-label="add-demand"
                      style={{ marginLeft: 5 }}
                      disabled
                      color="primary"
                    >
                      <AddIcon />
                    </IconButton>
                  )}
                  {numberKeyResult != 1 ? (
                    <IconButton
                      aria-label="delete"
                      disabled={disabled}
                      style={{
                        marginLeft: 5,
                        backgroundColor: "#dd99b1",
                        color: "#ab003c",
                      }}
                    >
                      <DeleteIcon
                        onClick={() => setNumberKeyResult(numberKeyResult - 1)}
                      />
                    </IconButton>
                  ) : (
                    <IconButton
                      aria-label="delete"
                      style={{ marginLeft: 5 }}
                      disabled
                      color="primary"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </>
              ) : null}
            </Grid>
            {/* กรอกข้อมูล detail */}
            <Grid container justifyContent="center" style={{ marginTop: 20 }}>
              <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
                <Grid container>
                  <Grid
                    item
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: 20 }}
                  >
                    <Typography style={{ fontSize: 17, fontWeight: "bold" }}>
                      Main data
                    </Typography>
                    <Typography style={{ fontSize: 15 }}>
                      description of the key result
                    </Typography>
                  </Grid>
                  <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
                    <TextField
                      name="keyResult1"
                      value={values.keyResult1}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <DriveFileRenameOutlineIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Key Result 1"
                      placeholder="Key Result 1"
                      //{...register("keyResult1", { required: true })}
                      /*
                      error={errors.keyResult1 ? true : false}
                      helperText={
                        errors.keyResult1 ? "Enter Objective Name" : ""
                      }
                       */
                    />
                    <TextField
                      name="description1"
                      value={values.description1}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      multiline
                      rows={2}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <NotesIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Description"
                      placeholder="Description"
                    />
                    {/*
                    <TextField
                      name="scope1"
                      value={values.scope1}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Crop32Icon />
                          </InputAdornment>
                        ),
                      }}
                      label="Scope"
                      placeholder="Scope"
                    />
                    */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xl={10}
                lg={10}
                md={10}
                sm={10}
                xs={10}
                style={{ marginTop: 10 }}
              >
                <Grid container>
                  <Grid
                    item
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: 20 }}
                  >
                    <Typography style={{ fontSize: 17, fontWeight: "bold" }}>
                      Second data
                    </Typography>
                    <Typography style={{ fontSize: 15 }}>
                      detail of the key result
                    </Typography>
                  </Grid>
                  <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
                    <TextField
                      name="tactics1"
                      value={values.tactics1}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AutoFixHighIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Tactics"
                      placeholder="Tactics"
                    />
                    <Grid container sx={{ paddingBottom: 2 }}>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            margin="normal"
                            format="dd/MM/yyyy"
                            style={{ width: "90%" }}
                            variant="inline"
                            value={values.dateStart1}
                            disabled={disabled}
                            onChange={(date) => {
                              setValues({
                                ...values,
                                dateStart1: date,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            margin="normal"
                            format="dd/MM/yyyy"
                            style={{ width: "90%" }}
                            value={values.dateEnd1}
                            disabled={disabled}
                            sx={{ paddingBottom: 2 }}
                            onChange={(date) => {
                              setValues({
                                ...values,
                                dateEnd1: date,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                    <FormControl sx={{ paddingBottom: 2 }} fullWidth>
                      <InputLabel>Select Validate</InputLabel>
                      <Select
                        name="validPerson1"
                        label="Select Validate"
                        value={values.validPerson1}
                        onChange={handleInputChange}
                        disabled={disabled}
                      >
                        {validator.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            style={{ display: "grid" }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      name="measureEvidence1"
                      value={values.measureEvidence1}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EscalatorIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Measure Evidence"
                      placeholder="Measure Evidence"
                      //{...register("measureEvidence1", { required: true })}
                      /*
                      error={errors.measureEvidence1 ? true : false}
                      helperText={
                        errors.measureEvidence1 ? "Enter Measure Evidence" : ""
                      }
                       */
                    />
                    <TextField
                      name="commitQuality1"
                      value={values.commitQuality1}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EqualizerIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Commit Quality"
                      placeholder="Commit Quality"
                      //{...register("commitQuality1", { required: true })}
                      /*
                      error={errors.commitQuality1 ? true : false}
                      helperText={
                        errors.commitQuality1 ? "Enter Measure Evidence" : ""
                      }
                       */
                    />
                    <FormControl sx={{ paddingBottom: 2 }} fullWidth>
                      <InputLabel>Select Type</InputLabel>
                      <Select
                        name="krType1"
                        value={values.krType1}
                        label="Select Type"
                        onChange={handleInputChange}
                        disabled={disabled}
                      >
                        {krType.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id == "None" ? "" : item.id}
                            style={{ display: "grid" }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid container item justifyContent="center">
              {location.isInfo == true ? (
                <div style={{ paddingBottom: "16px" }}>
                  <i className={
                      values.moonShotKR1 == 1
                        ? classes.moonShot_Active
                        : classes.moonShot_NotAcive
                    } class="fa-solid fa-space-station-moon"></i>
                  
                  <p style={{ textAlign: "center" }}>Moon Shot Stamp</p>
                </div>
              ) : null}
            </Grid>
          </Grid>

          {/* Kr2 */}
          <Box style={numberKeyResult < 2 ? { display: "none" } : {}}>
            <hr className="hrTag" />
            <Grid
              container
              direction="row"
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              <Grid item xl={4} lg={4} md={6} xs={8}>
                <Typography
                  sx={{ color: "primary.main" }}
                  className={classes.name}
                >
                  {/* <VpnKeyRoundedIcon fontSize='large' className='svgKey' /> */}
                  Key Result 2
                </Typography>
              </Grid>
              <Grid
                item
                xl={8}
                lg={8}
                md={6}
                xs={4}
                style={{ textAlign: "end" }}
              >
                {!disabled ? (
                  <>
                    {numberKeyResult < 3 ? (
                      <IconButton
                        aria-label="add-demand"
                        style={{
                          marginRight: 5,
                          backgroundColor: "#7dc581",
                          color: "#357a38",
                        }}
                      >
                        <AddIcon
                          onClick={() => {
                            setNumberKeyResult(numberKeyResult + 1);
                          }}
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="add-demand"
                        style={{ marginLeft: 5 }}
                        disabled
                        color="primary"
                      >
                        <AddIcon />
                      </IconButton>
                    )}
                    {numberKeyResult != 1 ? (
                      <IconButton
                        aria-label="delete"
                        disabled={disabled}
                        style={{
                          marginLeft: 5,
                          backgroundColor: "#dd99b1",
                          color: "#ab003c",
                        }}
                      >
                        <DeleteIcon
                          onClick={() =>
                            setNumberKeyResult(numberKeyResult - 1)
                          }
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="delete"
                        style={{ marginLeft: 5 }}
                        disabled
                        color="primary"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </>
                ) : null}
              </Grid>
            </Grid>
            {/* กรอกข้อมูล detail */}
            <Grid container justifyContent="center" style={{ marginTop: 20 }}>
              <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
                <Grid container>
                  <Grid
                    item
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: 20 }}
                  >
                    <Typography style={{ fontSize: 17, fontWeight: "bold" }}>
                      Main data
                    </Typography>
                    <Typography style={{ fontSize: 15 }}>
                      description of the key result
                    </Typography>
                  </Grid>
                  <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
                    <TextField
                      name="keyResult2"
                      value={values.keyResult2}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <DriveFileRenameOutlineIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Key Result 2"
                      placeholder="Key Result 2"
                      //{...register("keyResult2", { required: true })}
                      /*
                      error={errors.keyResult2 ? true : false}
                      helperText={
                        errors.keyResult1 ? "Enter Objective Name" : ""
                      }
                       */
                    />
                    <TextField
                      name="description2"
                      value={values.description2}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      multiline
                      rows={2}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <NotesIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Description"
                      placeholder="Description"
                    />
                    {/*
                    <TextField
                      name="scope2"
                      value={values.scope2}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Crop32Icon />
                          </InputAdornment>
                        ),
                      }}
                      label="Scope"
                      placeholder="Scope"
                    />
                    */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xl={10}
                lg={10}
                md={10}
                sm={10}
                xs={10}
                style={{ marginTop: 10 }}
              >
                <Grid container>
                  <Grid
                    item
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: 20 }}
                  >
                    <Typography style={{ fontSize: 17, fontWeight: "bold" }}>
                      Second data
                    </Typography>
                    <Typography style={{ fontSize: 15 }}>
                      detail of the key result
                    </Typography>
                  </Grid>
                  <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
                    <TextField
                      name="tactics2"
                      value={values.tactics2}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AutoFixHighIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Tactics"
                      placeholder="Tactics"
                    />
                    <Grid container sx={{ paddingBottom: 2 }}>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            margin="normal"
                            format="dd/MM/yyyy"
                            style={{ width: "90%" }}
                            variant="inline"
                            value={values.dateStart2}
                            disabled={disabled}
                            onChange={(date) => {
                              setValues({
                                ...values,
                                dateStart2: date,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            margin="normal"
                            format="dd/MM/yyyy"
                            style={{ width: "90%" }}
                            value={values.dateEnd2}
                            disabled={disabled}
                            onChange={(date) => {
                              setValues({
                                ...values,
                                dateEnd2: date,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                    <FormControl sx={{ paddingBottom: 2 }} fullWidth>
                      <InputLabel>Select Validate</InputLabel>
                      <Select
                        name="validPerson2"
                        label="Select Validate"
                        value={values.validPerson2}
                        onChange={handleInputChange}
                        disabled={disabled}
                      >
                        {validator.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            style={{ display: "grid" }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      name="measureEvidence2"
                      value={values.measureEvidence2}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EscalatorIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Measure Evidence"
                      placeholder="Measure Evidence"
                    />
                    <TextField
                      name="commitQuality2"
                      value={values.commitQuality2}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EqualizerIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Commit Quality"
                      placeholder="Commit Quality"
                    />
                    <FormControl sx={{ paddingBottom: 2 }} fullWidth>
                      <InputLabel>Select Type</InputLabel>
                      <Select
                        name="krType2"
                        value={values.krType2}
                        label="Select Type"
                        onChange={handleInputChange}
                        disabled={disabled}
                      >
                        {krType.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id == "None" ? "" : item.id}
                            style={{ display: "grid" }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container justifyContent="center">
              <Grid container item justifyContent="center">
                {location.isInfo == true ? (
                  <div style={{ paddingBottom: "16px" }}>
                    <i className={
                        values.moonShotKR2 == 1
                          ? classes.moonShot_Active
                          : classes.moonShot_NotAcive
                      } class="fa-solid fa-space-station-moon"></i>
                    
                    <p style={{ textAlign: "center" }}>Moon Shot Stamp</p>
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </Box>

          {/* Kr3 */}
          <Box style={numberKeyResult < 3 ? { display: "none" } : {}}>
            <hr className="hrTag" />
            <Grid
              container
              direction="row"
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              <Grid item xl={4} lg={4} md={6} xs={8}>
                <Typography
                  sx={{ color: "primary.main" }}
                  className={classes.name}
                >
                  Key Result 3
                </Typography>
              </Grid>
              <Grid
                item
                xl={8}
                lg={8}
                md={6}
                xs={4}
                style={{ textAlign: "end" }}
              >
                {!disabled ? (
                  <>
                    {numberKeyResult < 3 ? (
                      <IconButton
                        aria-label="add-demand"
                        style={{
                          marginRight: 5,
                          backgroundColor: "#7dc581",
                          color: "#357a38",
                        }}
                      >
                        <AddIcon
                          onClick={() => {
                            setNumberKeyResult(numberKeyResult + 1);
                          }}
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="add-demand"
                        style={{ marginLeft: 5 }}
                        disabled
                        color="primary"
                      >
                        <AddIcon />
                      </IconButton>
                    )}
                    {numberKeyResult != 1 ? (
                      <IconButton
                        aria-label="delete"
                        disabled={disabled}
                        style={{
                          marginLeft: 5,
                          backgroundColor: "#dd99b1",
                          color: "#ab003c",
                        }}
                      >
                        <DeleteIcon
                          onClick={() =>
                            setNumberKeyResult(numberKeyResult - 1)
                          }
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="delete"
                        style={{ marginLeft: 5 }}
                        disabled
                        color="primary"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </>
                ) : null}
              </Grid>
            </Grid>
            {/* กรอกข้อมูล detail */}
            <Grid container justifyContent="center" style={{ marginTop: 20 }}>
              <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
                <Grid container>
                  <Grid
                    item
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: 20 }}
                  >
                    <Typography style={{ fontSize: 17, fontWeight: "bold" }}>
                      Main data
                    </Typography>
                    <Typography style={{ fontSize: 15 }}>
                      description of the key result
                    </Typography>
                  </Grid>
                  <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
                    <TextField
                      name="keyResult3"
                      value={values.keyResult3}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <DriveFileRenameOutlineIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Key Result 3"
                      placeholder="Key Result 3"
                    />
                    <TextField
                      name="description3"
                      value={values.description3}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      multiline
                      rows={2}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <NotesIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Description"
                      placeholder="Description"
                    />
                    {/*
                    <TextField
                      name="scope3"
                      value={values.scope3}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Crop32Icon />
                          </InputAdornment>
                        ),
                      }}
                      label="Scope"
                      placeholder="Scope"
                    />
                    */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xl={10}
                lg={10}
                md={10}
                sm={10}
                xs={10}
                style={{ marginTop: 10 }}
              >
                <Grid container>
                  <Grid
                    item
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ marginBottom: 20 }}
                  >
                    <Typography style={{ fontSize: 17, fontWeight: "bold" }}>
                      Second data
                    </Typography>
                    <Typography style={{ fontSize: 15 }}>
                      detail of the key result
                    </Typography>
                  </Grid>
                  <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
                    <TextField
                      name="tactics3"
                      value={values.tactics3}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      // multiline
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AutoFixHighIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Tactics"
                      placeholder="Tactics"
                    />
                    <Grid container sx={{ paddingBottom: 2 }}>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            margin="normal"
                            format="dd/MM/yyyy"
                            style={{ width: "90%" }}
                            variant="inline"
                            value={values.dateStart3}
                            disabled={disabled}
                            onChange={(date) => {
                              setValues({
                                ...values,
                                dateStart3: date,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            margin="normal"
                            format="dd/MM/yyyy"
                            style={{ width: "90%" }}
                            value={values.dateEnd3}
                            disabled={disabled}
                            onChange={(date) => {
                              setValues({
                                ...values,
                                dateEnd3: date,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                    <FormControl sx={{ paddingBottom: 2 }} fullWidth>
                      <InputLabel>Select Validate</InputLabel>
                      <Select
                        name="validPerson3"
                        label="Select Validate"
                        value={values.validPerson3}
                        onChange={handleInputChange}
                        disabled={disabled}
                      >
                        {validator.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            style={{ display: "grid" }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      name="measureEvidence3"
                      value={values.measureEvidence3}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EscalatorIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Measure Evidence"
                      placeholder="Measure Evidence"
                    />
                    <TextField
                      name="commitQuality3"
                      value={values.commitQuality3}
                      onChange={handleInputChange}
                      fullWidth
                      disabled={disabled}
                      sx={{ paddingBottom: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EqualizerIcon />
                          </InputAdornment>
                        ),
                      }}
                      label="Commit Quality"
                      placeholder="Commit Quality"
                    />
                    <FormControl sx={{ paddingBottom: 2 }} fullWidth>
                      <InputLabel>Select Type</InputLabel>
                      <Select
                        name="krType3"
                        value={values.krType3}
                        label="Select Type"
                        onChange={handleInputChange}
                        disabled={disabled}
                      >
                        {krType.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id == "None" ? "" : item.id}
                            style={{ display: "grid" }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container justifyContent="center">
              <Grid container item justifyContent="center">
                {location.isInfo == true ? (
                  <div style={{ paddingBottom: "16px" }}>
                    <i className={
                        values.moonShotKR3 == 1
                          ? classes.moonShot_Active
                          : classes.moonShot_NotAcive
                      } class="fa-solid fa-space-station-moon"></i>
                    
                    <p style={{ textAlign: "center" }}>Moon Shot Stamp</p>
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </Box>
          {disabled ? null : (
            <>
              <hr className="hrTag" />
              <Box sx={{ paddingRight: 4 }}>
                <Grid container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      className="saveButton"
                      type="submit"
                      onClick={handleOnSubmit}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </form>
      </div>
    </ContainerStyled>
  );
}

export default IndividualPlan;
